import React from "react";
import { Typography, Box } from "@mui/material";
import Header from '../header/header';
import Footer from '../commun/Footer';
import SidebarFichesMetiers from "../commun/SidebarFichesMetiers";
import "./Cgu.css";

const FicheIngenieurCloud = () => (
  <>
    <Header />
    <div className="fiche-layout">
      <Box className="fiche-main" component="section">
        <Typography variant="h5" gutterBottom>
          ☁️ Recruter un Ingénieur Cloud (AWS / Azure / GCP)
        </Typography>
        <Typography variant="h6" gutterBottom>
          Description du poste
        </Typography>
        <Typography paragraph>
          L’Ingénieur Cloud conçoit, déploie et maintient des infrastructures IT dans des environnements cloud publics (AWS, Azure, GCP). Il permet aux entreprises de gagner en flexibilité, en scalabilité et en sécurité. Sa mission est essentielle pour accompagner les migrations cloud, automatiser les déploiements et garantir la haute disponibilité des services.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Missions principales
        </Typography>
        <ul className="cgu-list">
          <li>Concevoir des architectures cloud sécurisées, évolutives et résilientes</li>
          <li>Mettre en œuvre des solutions IaaS, PaaS, SaaS selon les besoins métiers</li>
          <li>Migrer les systèmes on-premise vers le cloud</li>
          <li>Automatiser les déploiements (Infrastructure as Code : Terraform, CloudFormation)</li>
          <li>Monitorer, sécuriser et optimiser les performances des environnements cloud</li>
          <li>Collaborer avec les équipes DevOps, sécurité et développement</li>
        </ul>

        <Typography variant="h6" gutterBottom>
          Compétences clés
        </Typography>
        <ul className="cgu-list">
          <li>Maîtrise des plateformes cloud : AWS, Microsoft Azure, Google Cloud Platform (GCP)</li>
          <li>Outils IaC : Terraform, Ansible, CloudFormation</li>
          <li>Conteneurisation : Docker, Kubernetes</li>
          <li>Scripting : Bash, Python</li>
          <li>Solides connaissances en réseaux, sécurité et supervision (CloudWatch, Azure Monitor…)</li>
        </ul>

        <Typography variant="h6" gutterBottom>
          Profils recherchés / Niveaux d’expérience
        </Typography>
        <ul className="cgu-list">
          <li>Junior : mise en place d’environnements simples ou support cloud</li>
          <li>Confirmé : projets de migration, configuration avancée multi-services</li>
          <li>Senior / Architecte : architecture multi-cloud, haute disponibilité, sécurité avancée</li>
        </ul>

        <Typography variant="h6" gutterBottom>
          Tarifs / TJM indicatifs
        </Typography>
        <ul className="cgu-list">
          <li>Junior : 350–450 € / jour</li>
          <li>Confirmé : 500–700 € / jour</li>
          <li>Senior / Architecte Cloud : 750–1 000 € / jour</li>
        </ul>


      </Box>
      <Box className="fiche-sidebar" component="aside">
        <SidebarFichesMetiers />
      </Box>
    </div>
    <Footer />
  </>
);

export default FicheIngenieurCloud;
